window.addEventListener('DOMContentLoaded', () => {

  const buttons = Array.from(document.querySelectorAll('.column__link-js'))
  const targets = document.querySelectorAll('.faq__info-block-js')

  function scrollToSection(section) {
  
    if (section) {
      const sectionTop = section.getBoundingClientRect().top;
  
      const offset = 200
  
      window.scrollBy({
        top: sectionTop - offset,
        behavior: 'smooth',
      });
    }
  }
  
  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const currentSection = targets[Number(btn.getAttribute('data-number'))]
      scrollToSection(currentSection);
    });
  });
});